import InstructionFeedbackForm from 'react-scale/components/scalers/tasks/common/InstructionFeedbackForm';
import DetailedFeedbackForm from 'react-scale/components/scalers/tasks/common/DetailedFeedbackForm';
import React, { useState, useEffect } from 'react';
import apiFetch from '@scale/frontend-lib/api-fetch';
import _ from 'lodash';

interface InstructionFeedbackFormWrapperProps {
  projectId?: string;
  taskTimer?: any;
  openModal: boolean;
  subtask: string;
  onClose: () => void;
  setSubmit: () => void;
  labels: string[];
  lidar?: boolean;
  isScaleStudio?: boolean;
  feedbackRequired?: boolean;
  readOnly?: boolean;
}

const CONFIDENCE_DICT: Record<string, boolean | undefined> = {
  '0.5': undefined,
  '1': true,
  '0': false,
};

const InstructionFeedbackFormWrapper: React.FC<InstructionFeedbackFormWrapperProps> = ({
  projectId,
  taskTimer,
  openModal,
  subtask,
  onClose,
  setSubmit,
  labels,
  lidar,
  isScaleStudio,
  feedbackRequired = false,
  readOnly = false,
}) => {
  const [isConfident, setIsConfident] = useState<boolean | undefined>(undefined);
  const [text, setText] = useState('');
  const [originalText, setOriginalText] = useState('');
  const [taggedLabels, setTaggedLabels] = useState<string[]>([]);
  const [canBypassFeedback, setCanBypassFeedback] = useState(false);

  // HACK for calibration task feedback experiment
  const isDetailedFeedbackMode = projectId === '6381a25a4f69350021336d35';

  useEffect(() => {
    setText('');
  }, [subtask]);

  // fill in existing feedbacks

  useEffect(() => {
    if (openModal && text === '') {
      let cancelled = false;

      const fetchData = async (cancelled: boolean) => {
        // fetch the instruction feedback
        const query = { subtask };
        const { instructionFeedback, canBypassFeedback: _canBypassFeedback } = await apiFetch(
          null,
          `internal/self_serve/fetch_instruction_feedback`,
          { query },
        );

        if (!cancelled) {
          const curText = _.get(instructionFeedback, 'text', '');
          setText(curText);
          setOriginalText(curText);
          const confidenceValue = _.get(instructionFeedback, 'confidence', '0.5');
          const confidence = CONFIDENCE_DICT[confidenceValue];
          setIsConfident(confidence);
          setCanBypassFeedback(_canBypassFeedback);
        }
      };

      fetchData(cancelled);
      return function cleanup() {
        cancelled = true;
      };
    }
  }, [openModal]);

  if (openModal) {
    if (isDetailedFeedbackMode) {
      return (
        <DetailedFeedbackForm
          taskTimer={taskTimer}
          subtask={subtask}
          onClose={onClose}
          setSubmit={setSubmit}
          labels={labels}
          text={text}
          originalText={originalText}
          taggedLabels={taggedLabels}
          onChange={(e: $FIXME) => {
            setText(e.target.value);
          }}
          onAdd={(e: $FIXME) => {
            const labelSet = new Set(taggedLabels);
            labelSet.add(e.toString());
            setTaggedLabels(Array.from(labelSet));
          }}
          feedbackRequired={feedbackRequired}
          readOnly={readOnly}
        />
      );
    }
    return (
      <InstructionFeedbackForm
        taskTimer={taskTimer}
        subtask={subtask}
        onClose={onClose}
        setSubmit={setSubmit}
        labels={labels}
        text={text}
        originalText={originalText}
        taggedLabels={taggedLabels}
        onChange={(e: $FIXME) => {
          setText(e.target.value);
        }}
        onAdd={(e: $FIXME) => {
          const labelSet = new Set(taggedLabels);
          labelSet.add(e.toString());
          setTaggedLabels(Array.from(labelSet));
        }}
        onSetConfidence={(val: boolean) => setIsConfident(val)}
        isConfident={isConfident}
        lidar={lidar}
        isScaleStudio={isScaleStudio}
        feedbackRequired={feedbackRequired && !canBypassFeedback}
        readOnly={readOnly}
      />
    );
  } else {
    return <div></div>;
  }
};

export default InstructionFeedbackFormWrapper;
